import { Table } from 'reactstrap';
import InstancesListHeader from './InstancesListHeader';
import { InstancesListBody } from './InstancesListBody';

const InstancesList = (props) => {
    const { instances, selectedInstanceIds, handleSelectSingleInstanceClick } =
        props;

    return (
        <Table striped className="text-light">
            <InstancesListHeader />
            <InstancesListBody
                instances={instances}
                selectedInstanceIds={selectedInstanceIds}
                handleSelectSingleInstanceClick={
                    handleSelectSingleInstanceClick
                }
            />
        </Table>
    );
};

export default InstancesList;
